import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

var EventImage = createReactClass({

    propTypes: {
        thumbnail: pt.string
    },

    getInitialState: function () {
        return {
            set: false,
            error: false
        };
    },

    shouldComponentUpdate: function (nextProps, nextState) {
        return (
            this.state != nextState ||
            this.props.thumbnail != nextProps.thumbnail
        )
    },
    
    componentWillReceiveProps: function (nextProps) {
        if (this.props !== nextProps) {
            this.setState(this.getInitialState());
        }
    },

    onLoad: function () {
        this.setState({
            set: true,
            error: false
        });
    },

    onError: function () {
        this.setState({
            set: true,
            error: true
        });
    },

    render: function () {
        var { state, props, onLoad, onError } = this;
        var image = state.error ? <i className="far fa-image fa-2"/> : <img onLoad={onLoad} onError={onError} src={props.thumbnail}/>;
        return (<div className={'asset-thumb' + (!state.error ? ' thumbnail' : ' thumbnail icon-thumbnail')}>
            {image}
        </div>);
    }

});

export default EventImage;
